import { Box, Button, Grid, Typography } from "@mui/material";
import Sidebar from "../../components/sidebar/sidebar";
import CustomerTable from "../../components/customerComponent/CustomerTable";
import CreateCustomer from "../../components/customerComponent/customerCreation/CreateCustomer";
import { Routes, Route, useNavigate, Outlet } from "react-router-dom";
import CustomerDetails from "../../components/customerComponent/CustomerDetails";
import OverviewTabs from "../../components/customerComponent/overView/overviewTab";
import PermissionTable from "../../components/permissions/permissionsTable";
import CreateUser from "../../components/permissions/createUser";

function Permissions() {
  const navigate = useNavigate();
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
          <Box height={65} />
          <Box>
            <Typography variant="h4">Create / Update Permissions</Typography>
          </Box>

          <Box mt={1}>
            {/* Nested Routes will be rendered here */}
            <Routes>
              <Route path="/" element={<PermissionTable />} />
              <Route path="create-user" element={<CreateUser />} />
              <Route path="/:id" element={<CustomerDetails />} />
            </Routes>
          </Box>
        </Box>
      </Box>
      {/* Outlet is used for rendering nested routes if further nesting is needed */}
      <Outlet />
    </div>
  );
}

export default Permissions;
